import CourseElementModel from './CourseElementModel';
import { backend } from '../../setup';

class DaybreakModel extends CourseElementModel {
	
	constructor( json:Object ){
		super( json );
	}
	
	get date():string{
		return this.get<string>( 'date' ).split('T')[0];
	}
	
	set date( d:string ){
		this.set( 'date', d );	
	}

	// get date_as_string():string{
	// 	return this.get<string>( 'date_as_string' );	
	// }
	
	get time():string{
		return this.get<string>( 'time' );	
	}
	
	set time( t:string ){
		this.set( 'time', t );	
	}
}

export default DaybreakModel;

backend.mapper.toModel.add( 'App\\Daybreak', function( json:any ){
	return new DaybreakModel( json );
});
backend.mapper.toModel.alias( 'App\\DaybreakPreview', 'App\\Daybreak' );

backend.mapper.toJson.add( 'App\\Daybreak', function( model:DaybreakModel ) {
	return model.object();
});
